<template>
    <div class="col-12 regas-reg-form pt-3 pb-4">
        <h2 class="h1 mb-1">{{ heading }}</h2>
        <b>Enter your registration number</b>
        <VeeForm :validation-schema="regValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div" class="col-12">
            <form class="reg-form" @submit="handleSubmit($event, onValueAddRegSubmit)" method="post" action="/modal-submit" ref="valueAddForm">
                <div class="row gx-3 gy-2 w-100">
                    <div class="col-12 col-sm-6 pt-2 reg-wrapper">
                        <Popper :content="errors.reg_plate" arrow placement="top" class="w-100 m-0 border-0" :show="errors.reg_plate ? true : false">
                            <Field id="reg_plate" name="reg_plate" type="text" class="reg-input fw-bold" placeholder="Enter Reg" autocomplete="off" data-reg-input="1"/>
                        </Popper>
                    </div>
                    <div class="col-12 col-sm-6 pt-2">
                        <Popper :content="errors.reg_postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.reg_postcode ? true : false">
                            <Field id="reg_postcode" name="reg_postcode" type="text" class="form-control reg-postcode" v-model="updatedPostcode" placeholder="Enter postcode" data-reg-postcode-input="1"/>
                        </Popper>
                    </div>
                    <div class="col-12 pt-2">
                        <button type="submit" class="btn btn-primary" data-reg-submit="1">
                            <span class="m-0">{{ buttonText }}</span>
                        </button>
                    </div>
                </div>
            </form>
            <teleport to="body">
                <value-add-modal
                    :va-modal-open="vaModalOpen"
                    :va-name="vaName"
                    :value-add="fitter?.services?.available[0]"
                    :car="car"
                    :va-code="valueAddCode"
                    :gas-unknown="gasUnknown"
                    :postcode="updatedPostcode"
                    @close-modal="vaModalOpen = false"
                ></value-add-modal>
            </teleport>
        </VeeForm>
    </div>
</template>

<script>
    import { Form as VeeForm, Field } from 'vee-validate';
    import * as yup from 'yup';

    import valueAdd from '@shared/mixins/valueAdd';
    import form from '@shared/mixins/form';

    export default {
        props: ['postcode', 'heading', 'buttonText', 'vaName', 'valueAddCode'],
        mixins: [valueAdd, form],
        components: {
            VeeForm,
            Field
        },
        data() {
            const regValidationSchema = yup.object({
                'reg_plate': yup.string().required('registration is a required field'),
                'reg_postcode': yup.string().required('postcode is a required field').nullable()
            });

            return {
                regValidationSchema,
                vaModalOpen: false,
                updatedPostcode: this.postcode,
                gasUnknown: null
            }
        },
        mounted() {
            this.emitter.on('updatedCar', data => {
                this.car = data;

                if(this.valueAddCode.includes('RCAIRCON')) {
                    var carYear = (this?.car?.date).split('-');
                    this.gasUnknown = (parseInt(carYear[0]) >= 2014 && carYear[0] <= 2016) ? true : false;
                }
            });

            this.emitter.on('updatedFitter', data => {
                this.fitter = data;
            });
        },
        methods: {
        },
        computed: {

        }
    }
</script>
<style lang="scss" scoped>
    .regas-reg-form {
        background: #fff;
        padding-left: 15px;
        padding-right: 15px;
        border-radius: 4px;
        z-index: 10;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1), 0px 2px 8px rgba(0, 0, 0, 0.15);
        .reg-wrapper {
            .reg-input {
                width: 100%;
                border: 0;
                padding: 2.5px 5px;
                border-radius: 6px;
                background: #FDD52E !important;
                background-color: #FDD52E !important;
                border: 1px solid #CAAB25;
                text-align: center;
                color: #212121;
                font-size: 20px;
                text-transform: uppercase;
                height: 40px;
                &::placeholder {
                    color: #212121;
                    opacity: 1;
                }
            }
        }
        .btn {
            width: 100%;
        }
        .sub-heading, h3 {
            color: #fff;
            text-align: left;
            font-size: 18px;
        }
        button {
            p {
                font-weight: 400;
            }
        }
    }
</style>